import { useQnaSummary } from '../api/getQnaSummary';

export const useQnaTab = (resource, id) => {
  const { data: summary } = useQnaSummary(resource, id, { enabled: !!id });
  const isAnswerer = summary?.role === 'answerer';
  const dot = !isAnswerer && !!(summary?.unread?.published || summary?.unread?.sent);
  const counts = summary?.counts;
  const count = isAnswerer
    ? counts.published + counts.unanswered + counts.draft_notifications
    : counts?.published;

  return { label: 'Q&A', value: 'qna', count, dot };
};
